import { hasArrayElements } from "@/apiUtils/commonUtils";
import { CollectionPromotion } from "@/common/lib/types";
import RenderCurrencyInText from "../common/RenderCurrencyInText";
import IconPromotionBadge from "./IconPromotionBadge";

interface CollectionPromotionBannerProps {
  promotions?: CollectionPromotion[];
}

const CollectionPromotionBanner = ({ promotions }: CollectionPromotionBannerProps) => {
  if (!hasArrayElements(promotions)) {
    return null;
  }

  return (
    <div className="container mb-6 flex flex-col px-3 md:mb-9 md:px-12">
      {promotions?.map((promotion) => (
        <div
          key={promotion.id}
          className="flex w-full items-center justify-center gap-2 bg-[#e7f3e3] px-4 py-3"
        >
          <IconPromotionBadge className="h-6 w-6 shrink-0 text-black" />
          <p className="text-sm font-semibold text-black md:text-base">
            <RenderCurrencyInText text={promotion.name} />
          </p>
        </div>
      ))}
    </div>
  );
};

export default CollectionPromotionBanner;
